import { useState } from "react";
import { SimpleForm } from "react-admin";
import { RISK_INSIGHT_REPORT_REFRESH_STATUS } from "../Constants";
import InputLabel from '@mui/material/InputLabel';
import CustomCheckbox from "../../utils/CustomCheckbox";
import { Grid, IconButton, CircularProgress } from '@mui/material'
import { ellipsis, textColor } from '../Styles'
import Tooltip from '@mui/material/Tooltip'
import { RefreshIcon } from "./StyledIcons";
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CustomDialog from "../../utils/CustomDialog";

const REFRESH_ICON_MAP = {
  [RISK_INSIGHT_REPORT_REFRESH_STATUS.LOADING]: <CircularProgress size={20} sx={{ color: 'gray' }} />,
  [RISK_INSIGHT_REPORT_REFRESH_STATUS.SUCCESS]: <DownloadDoneIcon sx={textColor.gray} />,
  [RISK_INSIGHT_REPORT_REFRESH_STATUS.ERROR]: <ErrorOutlineIcon sx={textColor.gray} />,
};

const ReportAndFileSelector = (props) => {
  const {
    reportFormat,
    reportFilename,
    supplementaryFiles,
    onReportChange,
    onFileChange,
    riskInsightReportFilename,
    onRiskInsightReportChange,
    refreshRiskInsightsReportData,
    riskInsightReportRefreshStatus,
  } = props;

  const [isRiskInsightChecked, setIsRiskInsightChecked] = useState(true);
  const [openRegenerateConfirm, setOpenRegenerateConfirm] = useState(false);

  const handleRiskInsightChange = (event) => {
    setIsRiskInsightChecked(event.target.checked);
    onRiskInsightReportChange(event);
  };

  const isRefreshDisabled = !isRiskInsightChecked || riskInsightReportRefreshStatus !== null;
  const refreshTooltip = !isRiskInsightChecked
    ? "Select the risk insight report to regenerate"
    : riskInsightReportRefreshStatus === RISK_INSIGHT_REPORT_REFRESH_STATUS.SUCCESS
      ? "Report regenerated"
      : riskInsightReportRefreshStatus === RISK_INSIGHT_REPORT_REFRESH_STATUS.ERROR
        ? "Regeneration failed"
        : "Regenerate risk insight report";

  return (
    <SimpleForm toolbar={null}>
      <Grid container alignItems="center" flexWrap="nowrap">
        <Grid item>
          <CustomCheckbox
            defaultChecked
            onChange={onReportChange}
            id="report"
            value={reportFormat}
          />
        </Grid>
        <Grid item sx={ellipsis}>
          <Tooltip title={reportFilename} placement="top">
            <InputLabel>{reportFilename}</InputLabel>
          </Tooltip>
        </Grid>
      </Grid>
      {
        (riskInsightReportFilename !== "") &&
          <Grid
            container
            alignItems="center"
            flexWrap="nowrap"
            sx={{
              "&:hover .refresh-btn": {
                visibility: "visible",
              },
            }}
          >
            <Grid item>
              <CustomCheckbox
                defaultChecked
                onChange={handleRiskInsightChange}
                id="riskInsightReport"
                value={riskInsightReportFilename}
              />
            </Grid>
            <Grid item sx={ellipsis}>
              <Tooltip title={riskInsightReportFilename} placement="top">
                <InputLabel>{riskInsightReportFilename}</InputLabel>
              </Tooltip>
            </Grid>
            <Grid
              item
              className="refresh-btn"
              sx={{ visibility: riskInsightReportRefreshStatus !== null ? 'visible' : 'hidden' }}
            >
              <Tooltip title={refreshTooltip} placement="top">
                <span>
                  <IconButton
                    id="risk-insights-regenerate-button"
                    size="small"
                    onClick={() => setOpenRegenerateConfirm(true)}
                    disabled={isRefreshDisabled}
                    sx={{
                      padding: '3px',
                      '& svg': { fontSize: '20px !important' },
                    }}
                  >
                    {REFRESH_ICON_MAP[riskInsightReportRefreshStatus] ?? <RefreshIcon />}
                  </IconButton>
                </span>
              </Tooltip>
              <CustomDialog
                title="Regenerate Risk Insight Report"
                content={<p>Are you sure you want to regenerate the risk insight report?</p>}
                openDialog={openRegenerateConfirm}
                closeDialog={() => setOpenRegenerateConfirm(false)}
                handleSubmit={() => {
                  setOpenRegenerateConfirm(false);
                  refreshRiskInsightsReportData();
                }}
              />
            </Grid>
          </Grid>
      }
      {
        supplementaryFiles.map(file =>
        <Grid container alignItems="center" flexWrap="nowrap" key={file.fileDownloadUri}>
          <Grid item>
            <CustomCheckbox
              defaultChecked
              onChange={(event) => onFileChange(event, file.fileDownloadUri)}
              id={file.fileDownloadUri}
              value={file.fileDownloadUri}
            />
          </Grid>
          <Grid item sx={ellipsis}>
            <Tooltip title={file.fileName} placement="top">
              <InputLabel>{file.fileName}</InputLabel>
            </Tooltip>
          </Grid>
        </Grid>)
      }
    </SimpleForm>
  );
}

export default ReportAndFileSelector;
